import BrandingHeader from './BrandingHeader.vue';

export default BrandingHeader;
